import gql from 'graphql-tag'

/* Query que obtiene los datos de todas las organizaciones (PARA MÓDULO DE ADMINISTRADOR)*/
const DATA_ORGANIZATIONS = gql`
query Users {
  users {
    id
    companyName
    name
    lastName
    email
    tel
    role
    rfc
    razonSocial
    bank
    clabe
    billEmail
    validationStatus
    createdAt
  }
}
`

/* Query que obtiene los datos de la organización en la sección del calendario de organizador */
const DATA_ORGANIZER = gql`
query DataCompany($id: String!) {
  dataCompany(id: $id) {
    companyName
    profilePicture
    imgBackground
  }
}`

/* Query que obtiene la información para saber si el organizador ya fue validado */
const VALIDATION_STATUS = gql`
query CheckValidationStatus {
  checkValidationStatus {
    rfc
    razonSocial
    bank
    clabe
    billEmail
    validationStatus
  }
}
`

export {DATA_ORGANIZATIONS, DATA_ORGANIZER, VALIDATION_STATUS} 